import type {
  CreateDeliveryNotePdfExportPayload,
  CreateDeliveryNotePdfExportResponse,
} from './types';

import { ENDPOINT } from '~/constants/endpoints';

import { vestigasApi } from '~/services/kyClient';

import {
  zodCreateDeliveryNotePdfExportPayloadSchema,
  zodCreateDeliveryNotePdfExportResponseSchema,
} from './validations';

/**
 * Queues the PDFs of the selected delivery notes as a data export job.
 *
 * The backend rejects an empty selection, or one above its export limit, with
 * 400 and a localized reason in `detail`. Poll the returned job with
 * `fetchExportResult` for the download link.
 *
 * @param payload - Delivery note selection and output format.
 * @returns The queued job and request IDs.
 *
 * @see https://app.dev.vestigas.com/redoc#tag/Delivery-Note/operation/create_delivery_note_pdf_export_delivery_note_pdf_exports_post
 */
export const createDeliveryNotePdfExport = async (
  payload: CreateDeliveryNotePdfExportPayload,
) =>
  vestigasApi
    .post(ENDPOINT.DATA_EXPORT.CREATE_DELIVERY_NOTE_PDF_EXPORT(), {
      json: payload,
      validate: {
        body: zodCreateDeliveryNotePdfExportPayloadSchema,
        response: zodCreateDeliveryNotePdfExportResponseSchema,
      },
    })
    .json<CreateDeliveryNotePdfExportResponse>();
